import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import { useRouting } from 'hooks/useRouting';

export const AlignmentAccounLimitModal = ({
  isShowModal,
  hideModal,
}: {
  isShowModal: boolean;
  hideModal: () => void;
}) => {
  const routing = useRouting();
  const goSecurityaccounts = (): void => {
    routing.pushRouting({ path: `/securityaccounts` }, true);
  };

  return (
    <Modal2 isShow={isShowModal}>
      <div className="p-4 max-h-modal overflow-y-auto text-bluegray-700">
        <div className="flex flex-row">
          <div className="font-bold text-base">
            登録できる口座数は10件までです
          </div>
          <div
            className="icon-close ml-auto text-gray-500 cursor-pointer"
            onClick={hideModal}
          />
        </div>
        <div className="mt-4 text-sm">
          同一証券で登録できる口座数は10件までです。
          <br />
          新たに追加する場合は口座一覧より追加したい証券の口座の削除をお願いします。
        </div>
        <div className="flex flex-col items-center">
          <button
            className="mt-6 py-3 text-white bg-tradewell justify-center w-full text-base rounded-lg"
            onClick={goSecurityaccounts}>
            連携口座一覧へ移動する
          </button>
          <button
            onClick={hideModal}
            className="flex justify-center text-gray-500 mt-2 p-4 text-base">
            閉じる
          </button>
        </div>
      </div>
    </Modal2>
  );
};
